import { defineAsyncComponent } from 'vue'
import NtLoader from './components/general/NtLoader.vue'
import NtModuleError from './components/general/NtModuleError.vue'
import { useSystemStore } from './stores/system'

export default {
  install: (app) => {
    // Explicit manual async components
    const manual = {
      NtWysiwyg: () => import('./components/forms/NtWysiwyg.vue'),
      NtIconPicker: () => import('./components/forms/NtIconPicker.vue')
    }
    for (const key in manual) {
      app.component(
        key,
        defineAsyncComponent({
          loader: manual[key],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError
        })
      )
    }

    // All modules are async
    const modules = import.meta.glob('./modules/**/*.vue')
    for (const path in modules) {
      const name = path.match(/\/([A-z]+).vue$/i)
      if (!name || name.length < 2) {
        continue
      }
      app.component(
        name[1],
        defineAsyncComponent({
          loader: modules[path],
          loadingComponent: NtLoader,
          errorComponent: NtModuleError
        })
      )
    }

    // Function to link to a module page
    app.config.globalProperties.$routeToModule = (name, params) => {
      const store = useSystemStore()
      const route = store.routes.find((r) => r.modules.find((m) => m.component === name))
      if (!route || route.is_external) {
        console.warn(`Cannot link to module "${name}". It is not included on any page on this members hub.`)
        return null
      }

      try {
        return app.config.globalProperties.$router.resolve({
          name: `page${route.id}`,
          params
        })?.fullPath
      } catch (e) {
        console.warn(`Cannot link to module "${name}". The page it is on cannot be resolved.`, e)
        return null
      }
    }

    app.config.globalProperties.$routeToPage = (id) => {
      if (!id) {
        return null
      }

      const store = useSystemStore()
      const route = store.routes.find((r) => r.id === id)
      if (!route || route.is_external) {
        return null
      }

      const usesModels = route.modules.filter((m) => m.model !== null).length > 0
      if (usesModels) {
        return null
      }

      return app.config.globalProperties.$router.resolve({
        name: `page${id}`
      })?.fullPath
    }
  }
}
